import { createGlobalStateHook } from '@dateam/ark-react';

const inspectionRecordsGlobal = createGlobalStateHook<Nullable<App.InspectionWithRecordSync>>(null);

export const useInspectionRecordsState = inspectionRecordsGlobal.hook;
export const setInspectionRecordsState = inspectionRecordsGlobal.setState;
export const getInspectionRecordsState = inspectionRecordsGlobal.getState;